import { render, staticRenderFns } from "./select_opt.vue?vue&type=template&id=3edeed54&scoped=true"
import script from "./select_opt.vue?vue&type=script&lang=js"
export * from "./select_opt.vue?vue&type=script&lang=js"
import style0 from "./select_opt.vue?vue&type=style&index=0&id=3edeed54&prod&lang=scss&scoped=true"
import style1 from "./select_opt.vue?vue&type=style&index=1&id=3edeed54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edeed54",
  null
  
)

export default component.exports